(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sadoer-depilatoria"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sadoer-landing')) {
    customElements.define('sadoer-landing', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.addEventListener('change', event => {
          if (event.target.matches('[data-sl-visual-pack]')) this.selectPack(event.target);
        }, { signal });
        this.initializeGallery(signal);
        if (this.querySelector('[data-sl-delivery]')) {
          this.updateDeliveryDates();
          this.deliveryClock = setInterval(() => this.updateDeliveryDates(), 60000);
          document.addEventListener('visibilitychange', () => this.updateDeliveryDates(), { signal });
        }
        const selected = this.querySelector('[data-sl-visual-pack]:checked');
        if (selected) this.selectPack(selected);
        if (this.querySelector('[data-hours]')) {
          this.initializeCountdown();
          this.updateClock();
          this.clock = setInterval(() => this.updateClock(), 1000);
        }
        const sticky = this.querySelector('[data-sl-sticky]');
        const purchaseArea = this.querySelector('.sl-purchase-area');
        if (sticky && purchaseArea) {
          const updateSticky = () => {
            if (this.stickyFrame) return;
            this.stickyFrame = requestAnimationFrame(() => {
              sticky.hidden = purchaseArea.getBoundingClientRect().bottom > 0;
              this.stickyFrame = null;
            });
          };
          this.observer = new IntersectionObserver(updateSticky, { threshold: 0 });
          this.observer.observe(purchaseArea);
          window.addEventListener('scroll', updateSticky, { passive: true, signal });
          window.addEventListener('resize', updateSticky, { signal });
          updateSticky();
        }
      }
      initializeGallery(signal) {
        this.galleryTrack = this.querySelector('[data-sl-gallery-track]');
        if (!this.galleryTrack) return;
        this.gallerySlides = Array.from(this.galleryTrack.querySelectorAll('[data-sl-slide]'));
        this.galleryIndex = 0;
        this.addEventListener('click', event => {
          const thumbnail = event.target.closest('[data-sl-gallery-index]');
          const arrow = event.target.closest('[data-sl-gallery-step]');
          if (thumbnail) this.goToGalleryImage(Number(thumbnail.dataset.slGalleryIndex));
          if (arrow) this.goToGalleryImage(this.galleryIndex + Number(arrow.dataset.slGalleryStep));
        }, { signal });
        this.galleryTrack.addEventListener('keydown', event => {
          if (event.target !== this.galleryTrack) return;
          const targets = { ArrowRight: this.galleryIndex + 1, ArrowLeft: this.galleryIndex - 1, Home: 0, End: this.gallerySlides.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          this.goToGalleryImage(targets[event.key]);
        }, { signal });
        this.galleryTrack.addEventListener('scroll', () => {
          if (this.galleryFrame) return;
          this.galleryFrame = requestAnimationFrame(() => {
            this.galleryFrame = null;
            const width = this.galleryTrack.clientWidth;
            if (width) this.updateGalleryControls(Math.round(this.galleryTrack.scrollLeft / width));
          });
        }, { passive: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.gallerySlides.findIndex(slide => slide.dataset.slBlockId === event.detail?.blockId);
          if (index >= 0) this.goToGalleryImage(index, false);
        }, { signal });
        this.galleryResize = new ResizeObserver(() => this.goToGalleryImage(this.galleryIndex, false));
        this.galleryResize.observe(this.galleryTrack);
        this.updateGalleryControls(0);
      }
      goToGalleryImage(index, animate = true) {
        const target = Math.max(0, Math.min(this.gallerySlides.length - 1, index));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.galleryTrack.scrollTo({ left: this.galleryTrack.clientWidth * target, behavior: animate && !reducedMotion ? 'smooth' : 'instant' });
        if (!animate) this.updateGalleryControls(target);
      }
      updateGalleryControls(index) {
        this.galleryIndex = Math.max(0, Math.min(this.gallerySlides.length - 1, index));
        this.querySelectorAll('[data-sl-gallery-index]').forEach(button => {
          const active = Number(button.dataset.slGalleryIndex) === this.galleryIndex;
          button.classList.toggle('is-active', active);
          if (active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
        const counter = this.querySelector('[data-sl-gallery-current]');
        if (counter) counter.textContent = String(this.galleryIndex + 1);
        this.querySelectorAll('[data-sl-gallery-step]').forEach(button => {
          button.disabled = Number(button.dataset.slGalleryStep) < 0 ? this.galleryIndex === 0 : this.galleryIndex === this.gallerySlides.length - 1;
        });
      }
      calculateDeliveryDates(now, minimum, maximum, excludedDates) {
        const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
        const date = Object.fromEntries(parts.filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
        const order = new Date(Date.UTC(Number(date.year), Number(date.month) - 1, Number(date.day), 12));
        const excluded = new Set(excludedDates);
        const addBusinessDays = count => {
          const day = new Date(order);
          let remaining = count;
          while (remaining > 0) {
            day.setUTCDate(day.getUTCDate() + 1);
            const weekday = day.getUTCDay();
            if (weekday !== 0 && weekday !== 6 && !excluded.has(day.toISOString().slice(0, 10))) remaining--;
          }
          return day;
        };
        return { order, from: addBusinessDays(minimum), to: addBusinessDays(maximum) };
      }
      updateDeliveryDates() {
        const panel = this.querySelector('[data-sl-delivery]');
        if (!panel) return;
        const minimum = Math.max(1, Math.min(10, Number(panel.dataset.minDays) || 2));
        const maximum = Math.max(minimum, Math.min(10, Number(panel.dataset.maxDays) || 3));
        const excluded = (panel.dataset.excludedDates || '').split(/[\s,;]+/).filter(value => /^\d{4}-\d{2}-\d{2}$/.test(value));
        const dates = this.calculateDeliveryDates(new Date(), minimum, maximum, excluded);
        const dateKey = dates.order.toISOString();
        if (this.deliveryDateKey === dateKey) return;
        this.deliveryDateKey = dateKey;
        const formatter = new Intl.DateTimeFormat('es-CL', { day: 'numeric', month: 'short', timeZone: 'UTC' });
        const orderText = formatter.format(dates.order).replaceAll('.', '');
        let arrivalText = formatter.format(dates.from).replaceAll('.', '');
        if (dates.from.getTime() !== dates.to.getTime()) {
          arrivalText = dates.from.getUTCMonth() === dates.to.getUTCMonth() && dates.from.getUTCFullYear() === dates.to.getUTCFullYear()
            ? `${dates.from.getUTCDate()}–${formatter.format(dates.to).replaceAll('.', '')}`
            : `${arrivalText} – ${formatter.format(dates.to).replaceAll('.', '')}`;
        }
        panel.querySelector('[data-sl-order-date]').textContent = orderText;
        panel.querySelector('[data-sl-arrival-date]').textContent = arrivalText;
        panel.querySelector('[data-sl-delivery-dates]').hidden = false;
      }
      selectPack(radio) {
        this.querySelectorAll('.sl-pack').forEach(card => card.classList.toggle('is-selected', card.contains(radio)));
        const price = this.querySelector('[data-sl-sticky-price]');
        if (price) price.textContent = radio.dataset.formattedPrice;
      }
      initializeCountdown() {
        const duration = (Number(this.dataset.countdownHours) || 24) * 3600000;
        const key = this.dataset.countdownKey;
        this.countdownEnd = Date.now() + duration;
        try {
          const stored = Number(window.localStorage.getItem(key));
          if (Number.isFinite(stored) && stored > 0) this.countdownEnd = stored;
          else window.localStorage.setItem(key, String(this.countdownEnd));
        } catch {}
      }
      updateClock() {
        const remaining = Math.max(0, Math.ceil((this.countdownEnd - Date.now()) / 1000));
        this.querySelectorAll('[data-hours]').forEach(el => el.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0'));
        this.querySelectorAll('[data-minutes]').forEach(el => el.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0'));
        this.querySelectorAll('[data-seconds]').forEach(el => el.textContent = String(remaining % 60).padStart(2, '0'));
        this.querySelectorAll('[data-sl-promo-active]').forEach(el => el.hidden = remaining === 0);
        this.querySelectorAll('[data-sl-promo-expired]').forEach(el => el.hidden = remaining > 0);
      }
      disconnectedCallback() {
        this.abortController?.abort();
        clearInterval(this.clock);
        clearInterval(this.deliveryClock);
        this.galleryResize?.disconnect();
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame = null;
        this.deliveryDateKey = null;
        cancelAnimationFrame(this.stickyFrame);
        this.stickyFrame = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
